export default "__VITE_ASSET__D8Rf0Hp7__"